/*
  AURRA — UGC video strip.

  Deliberately small and dependency-free. It does four things:
    1. nothing downloads until a tap (the <video> ships preload="none")
    2. after the first tap the browser's OWN controls take over
    3. only one clip plays at a time
    4. a clip that scrolls away pauses itself

  It lives in an asset rather than inline in the section because a script that
  throws inside a Liquid section can leave Shopify caching a broken render for
  hours. Keep it here.
*/
(function () {
  "use strict";

  var section = document.querySelector("[data-aurra-ugc]");
  if (!section) return;

  var cards = Array.prototype.slice.call(
    section.querySelectorAll("[data-ugc-card]")
  );
  if (!cards.length) return;

  /** Stop every other clip, so two people never talk over each other. */
  function pauseOthers(except) {
    cards.forEach(function (card) {
      if (card === except) return;
      var v = card.querySelector("[data-ugc-video]");
      if (v && !v.paused) v.pause();
    });
  }

  function showError(card, video) {
    if (card.querySelector(".aurra-ugc__error")) return;
    card.classList.remove("is-playing");
    var p = document.createElement("p");
    p.className = "aurra-ugc__error";
    p.textContent = "This clip won't load right now. Try again in a moment.";
    card.appendChild(p);
    if (video) video.removeAttribute("controls");
  }

  function spinner(card, on) {
    var el = card.querySelector(".aurra-ugc__spinner");
    if (on && !el) {
      el = document.createElement("span");
      el.className = "aurra-ugc__spinner";
      el.setAttribute("aria-hidden", "true");
      card.appendChild(el);
    } else if (!on && el) {
      el.remove();
    }
  }

  cards.forEach(function (card) {
    var video = card.querySelector("[data-ugc-video]");
    var button = card.querySelector("[data-ugc-play]");
    if (!video || !button) return;

    var started = false;

    button.addEventListener("click", function () {
      if (started) return;
      started = true;

      pauseOthers(card);
      spinner(card, true);

      // preload="none" means there are no bytes yet; ask for them now.
      video.preload = "auto";
      video.load();

      /*
        A click IS a user gesture, so sound is allowed — and a customer
        tapping a fit video expects to hear it. But policies differ across
        iOS versions and in-app browsers (Instagram, TikTok), so if the
        unmuted attempt is refused, fall back to muted rather than showing
        a dead poster. Silent playback beats no playback.
      */
      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") {
        attempt.catch(function () {
          video.muted = true;
          var retry = video.play();
          if (retry && typeof retry.catch === "function") {
            retry.catch(function () {
              spinner(card, false);
              showError(card, video);
            });
          }
        });
      }
    });

    video.addEventListener("playing", function () {
      spinner(card, false);
      card.classList.add("is-playing");
      // Hand over to the native transport: scrubbing, volume, fullscreen and
      // captions all come free and behave correctly on every device.
      video.setAttribute("controls", "controls");
    });

    video.addEventListener("waiting", function () {
      spinner(card, true);
    });

    video.addEventListener("play", function () {
      pauseOthers(card);
    });

    video.addEventListener("error", function () {
      spinner(card, false);
      showError(card, video);
    });
  });

  /*
    Pause anything scrolled well out of view. On a phone this is the difference
    between one clip playing and three of them buffering in the background
    while the customer reads the size guide.
  */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var v = entry.target.querySelector("[data-ugc-video]");
          if (v && !v.paused) v.pause();
        });
      },
      { threshold: 0.25 }
    );
    cards.forEach(function (card) {
      io.observe(card);
    });
  }
})();
